import React, { useState, useEffect } from 'react'
import {
  Create,
  required,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useTranslate,
  NumberInput,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { clientServices } from 'src/services/reservation/client/client.service'

export const NumberingCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const [clients, setClients] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)

  useEffect(() => {
    getClient()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getClient = async () => {
    try {
      setLoadingClients(true)
      const allClients = await clientServices.getByAll()
      if (allClients) {
        setClients(allClients.map((client) => ({ ...client, client_id: client.id })))
        return
      }
      notify(`clients not found`, { type: 'error' })
    } catch (error) {
      notify(`clients not found`, { type: 'error' })
    } finally {
      setLoadingClients(false)
    }
  }

  const onSuccess = () => {
    notify('ra.notification.created_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.numbering') },
    })
    redirect('/numbering')
  }

  const onError = () => {
    notify('ra.notification.created_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.numbering') },
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_numbering')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.prefix')} required>
              <TextInput source='prefix' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.client')} required>
              {loadingClients ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='client_id'
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={clients}
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_branch_number')}>
              <NumberInput label='' source='document_branch_number' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.last_used')}>
              <NumberInput
                label=''
                source='last_used'
                fullWidth
                validate={[required()]}
                defaultValue={0}
              />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
